<div class="electronic-documents-adhesion">
    <div class="electronic-documents-adhesion__wrapper">
        <form [formGroup]="formGroup">
            <sc-checkbox
                class="checkbox"
                formControlName="adhered"
                [isReadOnly]="adhered">
                <span class="electronic-documents-adhesion__title">
                    {{ title }}
                </span>
            </sc-checkbox>
        </form>
        <p class="electronic-documents-adhesion__description">
            Asegurate que el email de tu cliente sea válido para que pueda recibir su póliza.
        </p>
    </div>
    <div *ngIf="formGroup.value.adhered === false">
        <sc-info-box class="error">
            <b>Si destildás "Adherir a póliza digital" tu cliente recibirá la documentación física dentro de los próximos 10 a 15 días.</b> 
        </sc-info-box>
    </div>
</div>